import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type ChaptersDTO =  {
    id:string;
    name:string;
    description:string;
    courseId:string;
    quizId:string;
    lectures:Lecture[];
    quiz:string;
    createdAt:string;
    updatedAt:string;
}
export type Lecture = {
    id: string;
    title:string
    videos: Video[];
    resources: Resources[];
}
type Video = {
    id: string;
    name:string;
    url: string;
    createdAt: string;
    updatedAt: string;
}
type Resources = {
    id: string;
    title: string;
    url: string;
    createdAt: string;
    updatedAt: string;
}
interface ChaptersData {
    chaptersData: ChaptersDTO[];
}
interface ChaptersResponse {
    data?: ChaptersData;
    error?: ApiError;
}
export interface CourseUpdatePayload {
    id: string;
    name: string;
    description: string;
    lectures: {
        id: string;
        title: string;
        videos: {
            id: string;
            name: string;
            url: string;
        }[];
        resources: {
            id: string;
            title: string;
            url: string;
        }[];
        quizizz: {
            id: string;
            title: string;
        }[];
    }[];
}


export const editCourse = async (chapterId:string, payload: CourseUpdatePayload): Promise<ChaptersResponse> => {
    try {
        const response = await axios.patch(`/chapter/${chapterId}`, payload);
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};